const env = {
  NODE_ENV: process.env.NODE_ENV,
  FIREBASE_SECRET: process.env.FIREBASE_SECRET,
  NODE_DATABASE: process.env.NODE_DATABASE,
  API_URL: process.env.API_URL,
  SEND_EMAIL_API: process.env.SEND_EMAIL_API,
  LINK_TEMPLATES_ZIP: process.env.LINK_TEMPLATES_ZIP,
  LINK_SHIPMENT_TRACKING_TEMPLATE_ZIP: process.env.LINK_SHIPMENT_TRACKING_TEMPLATE_ZIP,
  SECRET_ID: process.env.SECRET_ID,
  LINK_TEMPLATE_UPLOAD_CARTONS_CSV: process.env.LINK_TEMPLATE_UPLOAD_CARTONS_CSV,
  LINK_TEMPLATE_UPLOAD_CARTONS_CSV_TO_BR_PORT:
    process.env.LINK_TEMPLATE_UPLOAD_CARTONS_CSV_TO_BR_PORT,
  LINK_TEMPLATE_UPLOAD_CARTONS_CRITERION_CSV: process.env.LINK_TEMPLATE_UPLOAD_CARTONS_CRITERION_CSV,
  LINK_TEMPLATE_USER_CSV: process.env.LINK_TEMPLATE_USER_CSV,
  LINK_TEMPLATE_RECEIVE_CARTONS_CSV: process.env.LINK_TEMPLATE_RECEIVE_CARTONS_CSV,
  LINK_TEMPLATE_STORAGE_BOX_CSV: process.env.LINK_TEMPLATE_STORAGE_BOX_CSV,
  LINK_TEMPLATE_HSCODE_CSV: process.env.LINK_TEMPLATE_HSCODE_CSV,
  LINK_UPLOAD_CENTRE_TEMPLATES: process.env.LINK_UPLOAD_CENTRE_TEMPLATES,
  SEA_RATES_URL: process.env.SEA_RATES_URL,
  STRIPE_PUBLISHABLE_KEY:
    process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ||
    process.env.STRIPE_PUBLISHABLE_KEY ||
    process.env.APP_STRIPE_PUBLISHABLE_KEY,
  SENTRY_DSN:
    "https://415c0dfa495dd6f1721f72e1478803e0@o4508374366355456.ingest.us.sentry.io/4508759009525760",
  DUMONT_AI_URL: process.env.REACT_APP_DUMONT_AI_URL || process.env.DUMONT_AI_URL || "",
  DUMONT_CLIENT_IDENTIFIER: process.env.REACT_APP_DUMONT_CLIENT_IDENTIFIER || "shipeezi",
  DUMONT_DEFAULT_AGENT_ID:
    process.env.REACT_APP_DUMONT_DEFAULT_AGENT_ID || process.env.DUMONT_DEFAULT_AGENT_ID || "",
};

export default env;
